import { createEvent } from 'effector';

const $$app = {
    appLoaded: createEvent(),
};

export default $$app;
